import Vue from 'vue'
import router from '@/router'
import store from '@/store'

/**
 * api 接口
 * @type {string}
 */
export const apiURL = `${process.env.VUE_APP_API}`

/**
 * 日期格式
 * @type {Intl.DateTimeFormat}
 */
export const dateFormat = new Intl.DateTimeFormat('fr-CA', {
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour12: false
})

/**
 * 時間格式
 * @type {Intl.DateTimeFormat}
 */
export const timeFormat = new Intl.DateTimeFormat('en', {
  hour: 'numeric', minute: 'numeric', second: 'numeric',
  hour12: false
})

/**
 * 回應請求統一處理
 * @param err
 * @param resp
 * @param track
 * @param showErrorMessage
 * @returns {boolean|*} 成功回應=整個response 失敗=false
 */
export const responseFormat = function(err, resp, track = {}, showErrorMessage = true, apiName) {
  let result = { code: 0, result: null, pb: resp, err: err }
  if (err == null) {
    result = { code: 200, result: resp.toObject(), pb: resp }
    setApiQuery({ ...track, err, resp: resp.toObject() })
    return result
  }
  setApiQuery({ ...track, err, resp })
  // 錯誤是否都顯示
  if (showErrorMessage) Vue.prototype.$message({ message: `${apiName ? `${apiName} request error:` : ''} ${err.message} (${err.code})`, type: 'error' })
  return result
}

/**
 * API追蹤
 * @param data
 */
export const setApiQuery = function(data) {
  store.dispatch('app/setApiQuery', data)
}
